import * as Yup from 'yup'

export const schema = (t: (key: string) => string) => ({
  value: Yup.string().required(t('requiredMessage')),
  destinationBank: Yup.string().required(t('requiredMessage')),
  paymentMethod: Yup.string().required(t('requiredMessage')),
  paidAt: Yup.string().required(t('requiredMessage')),
})
